<template>
  <details-header :loading="loading" dense hide-avatar>
    <template v-slot:headerLine1>
      <span class="secondarytext--text">CorePortal</span>
    </template>
    <template v-slot:tabs>
      <v-tabs>
        <v-tab to="/portal/customers">
          Customers
        </v-tab>
        <v-tab to="/portal/partners" v-if="isSuperAdmin">
          Partners
        </v-tab>
        <v-tab to="/portal/corecoaches">
          CoreCoaches
        </v-tab>
        <v-tab to="/portal/billing">
          Billing
        </v-tab>
        <v-tab to="/portal/heatmap" v-if="isSuperAdmin">
          Heatmap
        </v-tab>
      </v-tabs>
    </template>
    <v-row>
      <v-col cols="12">
        <template v-if="tab == 'customers'">
          <customer-details
            v-if="customerId"
            :customer-id="customerId"
            v-on:delete="customerId = null"
          ></customer-details>
          <customer-list v-else></customer-list>
        </template>
        <template v-if="tab == 'corecoaches'">
          <core-coach-details
            v-if="coreCoachId"
            :core-coach-id="coreCoachId"
            v-on:delete="$router.push({ path: `/portal/corecoaches` })"
          ></core-coach-details>
          <core-coaches-list v-else></core-coaches-list>
        </template>
        <partners-list v-if="tab == 'partners' && isSuperAdmin"></partners-list>
        <partner-billing-overview
          v-if="tab == 'billing'"
        ></partner-billing-overview>
        <pulse-heatmap
          v-if="tab == 'heatmap'"
          :filter="heatmap_filter"
          companies
        ></pulse-heatmap>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import DetailsHeader from "@/components/common/DetailsHeader";
import CustomerList from "@/components/portal/CustomerList";
import CoreCoachesList from "@/components/portal/CoreCoachesList";
import PartnersList from "@/components/portal/PartnersList";
import CustomerDetails from "@/components/portal/CustomerDetails";
import CoreCoachDetails from "@/components/portal/CoreCoachDetails";
import PartnerBillingOverview from "@/components/portal/PartnerBillingOverview";
import PulseHeatmap from "@/components/pulse/PulseHeatmap";
export default {
  name: "CorePortal",
  components: {
    DetailsHeader,
    CustomerList,
    CoreCoachesList,
    PartnersList,
    CustomerDetails,
    CoreCoachDetails,
    PartnerBillingOverview,
    PulseHeatmap
  },
  data: () => ({
    tab: null,
    loading: false,
    customerId: null,
    coreCoachId: null,
    heatmap_filter: null
  }),
  computed: {
    isSuperAdmin() {
      return this.$auth.isSuperAdmin();
    },

    ...mapGetters({
      timeframe: "reporting/timeframe"
    })
  },
  created() {
    this.updateTab();
    this.heatmap_filter = {
      timeframeId:
        this.timeframe.timeframeId || this.$enums.timeframes.LAST_90_DAYS,
      customStartDate: this.timeframe.customStartDate,
      customEndDate: this.timeframe.customEndDate,
      customTimezone: this.timeframe.customTimezone,
      breakdownId: "companies"
    };
  },
  methods: {
    updateTab() {
      let tab = this.$route.params.tab;
      let id = this.$route.params.id;
      if (id) {
        switch (tab) {
          case "customers":
            this.customerId = id;
            break;
          case "corecoaches":
            this.coreCoachId = id;
            break;
        }
      }
      this.tab = tab;
    }
  }
};
</script>
